export const onRouteUpdate = (
  { location },
  pluginOptions = { stripQueryString: false }
) => {
  const domElem = document.querySelector(`meta[property='og:url']`);
  const existingValue = domElem.getAttribute(`content`);
  const baseProtocol = domElem.getAttribute(`data-baseProtocol`);
  const baseHost = domElem.getAttribute(`data-baseHost`);

  if (existingValue && baseProtocol && baseHost) {
    let value = `${baseProtocol}//${baseHost}${location.pathname}`;

    const { stripQueryString } = pluginOptions;

    if (!stripQueryString) {
      value += location.search;
    }

    value += location.hash;

    domElem.setAttribute(`content`, `${value}`);
  }

  if (typeof window !== 'undefined' && window._paq) {
    const originalTitle = document.title;

    const observer = new MutationObserver(() => {
      const newTitle = document.title;
      if (newTitle !== originalTitle) {
        window._paq.push(['setCustomUrl', location.href]);
        window._paq.push(['setDocumentTitle', newTitle]);
        window._paq.push(['trackPageView']);
        observer.disconnect();
      }
    });

    const titleEl = document.querySelector('title');
    if (titleEl) {
      observer.observe(titleEl, { childList: true });
    } else {
      window._paq.push(['setCustomUrl', location.href]);
      window._paq.push(['setDocumentTitle', location.pathname]);
      window._paq.push(['trackPageView']);
    }
  }
};

export const onClientEntry = () => {
  if (typeof window !== 'undefined') {
    const storedLeadId = localStorage.getItem('LeadID');
    if (storedLeadId) {
      window._paq = window._paq || [];
      window._paq.push(['setUserId', storedLeadId]);
    }
  }
};
